<template>
  	<TransferLot />
</template>

<script>

// @ is an alias to /src
import TransferLot from "@/components/Client/PinBatch/TransferLot.vue";

export default {
  name: "TransferLots",
  components: {
    TransferLot,
  },
};
</script>
